import { render, staticRenderFns } from "./TierUpgradeNoticeModal.vue?vue&type=template&id=45c8fda1&scoped=true&"
import script from "./TierUpgradeNoticeModal.vue?vue&type=script&lang=ts&"
export * from "./TierUpgradeNoticeModal.vue?vue&type=script&lang=ts&"
import style0 from "./TierUpgradeNoticeModal.vue?vue&type=style&index=0&id=45c8fda1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c8fda1",
  null
  
)

export default component.exports